import { initLanguageSwitcher } from '../components/initLanguageSwitcher';
import { initRegistrationForm } from '../components/forms/initRegistrationForm';

document.addEventListener('DOMContentLoaded', handleOnLoadPage);

function handleOnLoadPage() {
    initLanguageSwitcher();
    initRegistrationForm();
}
